import moment from "moment";
export const getOrderFlowRecipeAssignments = (currentMeal, recipe, programMealId, date) => {
    var _a;
    return (_a = currentMeal === null || currentMeal === void 0 ? void 0 : currentMeal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.filter((ra) => {
        var _a;
        return ra.RecipeId === (recipe === null || recipe === void 0 ? void 0 : recipe.RecipeId) &&
            ((_a = recipe === null || recipe === void 0 ? void 0 : recipe.Assignments) === null || _a === void 0 ? void 0 : _a.some((a) => a.ProgramMealId === programMealId)) &&
            moment(ra.Date).isSame(date, "date");
    });
};
